enum AssetType {
    AUTOMOBILE = 'automobile',
    POWERSPORTS_VEHICLE = 'powersports_vehicle',
    RECREATIONAL_VEHICLE = 'recreational_vehicle',
}

export default AssetType
